export default class FinesseCartButton extends HTMLElement {
  active: boolean = false
  button: HTMLElement | null = null
  
  static get observedAttributes() {
    return ['active']
  }

  constructor() {
    super()

    this.button = this.querySelector<HTMLElement>('button[data-cart-button]') as HTMLElement

    (window as any).addEventListener('cart:toggle', this.handleCart.bind(this))
    this.button.addEventListener('click', this.handleClick.bind(this))
  }
  
  get isActive() {
    return this.active
  }

  set isActive(value: boolean) {
    this.active = value
    this.setAttribute('active', value.toString())
    // this.toggle()
  }

  handleCart(evt: CustomEvent) {
    // @ts-ignore
    this.isActive = evt.detail.active
  }

  handleClick(evt: Event) {
    evt.preventDefault()

    window.dispatchEvent(new CustomEvent('cart:toggle', { bubbles: true, detail: { active: !this.isActive } }))
  }
}

customElements.define('finesse-cart-button', FinesseCartButton)
